import React from 'react';
import { Link } from 'gatsby';
import Layout from '../Layout';
import {
  container,
  fourOhFour,
  paragraph,
  heading,
  link,
  list,
} from './FourOhFour.module.scss';

const FourOhFour = ({ links }) => (
  <Layout homepage>
    <div className={container}>
      <h2 className={heading}>Uuuups...</h2>
      <p className={paragraph}>
        Imamo problem, ne mogu pronaći stranicu koju tražiš.
        {links && 'MOžda neki od dole navedenih linkova mogu pomoći?'}
      </p>
      {links && (
        <ul className={list}>
          {links.map(({ href, text }, i) => (
            <li key={i}>
              <Link className={link} to={href}>
                {text}
              </Link>
            </li>
          ))}
        </ul>
      )}
      <span className={fourOhFour}>404</span>
    </div>
  </Layout>
);

export default FourOhFour;
